<template>
    <div class="custom-filter">
        <div class="custom-filter__inputs">
            <label class="custom-filter__inputs--label">
                Nom
                <input class="custom-filter__inputs--field" v-model="filters.last_name">
            </label>
            <label class="custom-filter__inputs--label">
                Prénom
                <input class="custom-filter__inputs--field" v-model="filters.first_name">
            </label>
            <label class="custom-filter__inputs--label">
                Email
                <input class="custom-filter__inputs--field" v-model="filters.email">
            </label>
            <label class="custom-filter__inputs--label">
                Tel
                <input class="custom-filter__inputs--field" v-model="filters.tel">
            </label>
        </div>
        <div class="custom-filter__buttons">
            <button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomFilter',
        data() {
            return {

            }
        },
        props: {
            filters: Object
        },
        methods: {
            emitFilters() {
                this.$eventBus.$emit('get-clients');
            }
        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Clients/CustomFilter.vue